import { render, staticRenderFns } from "./BaseControlLabel.vue?vue&type=template&id=44fbb059&lang=pug&"
import script from "./BaseControlLabel.vue?vue&type=script&lang=js&"
export * from "./BaseControlLabel.vue?vue&type=script&lang=js&"
import style0 from "./BaseControlLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports